<template>
	<div>
		<section
			id="experience"
			class="resume-section p-3 p-lg-5 d-flex flex-column"
		>
			<div class="container pt-5">
				<div class="row my-3">
					<div class="col-12 about-content-header text-center my-3">
						<span class="water-text">Experience</span>
						<h2 class="page-section-heading text-center mb-0">Experience</h2>
						<div class="divider-custom">
							<div class="divider-custom-line" />
							<div class="divider-custom-icon">
								<i class="fas fa-star" />
							</div>
							<div class="divider-custom-line" />
						</div>
					</div>

					<div id="award-box" class="main-award col-md-12">
						<div class="professional mx-auto w-75">
							<div class="resume-education">
								<h3 class="heading">Professional</h3>
								<div class="resume-content">
									<div class="resume-item">
										<h6 class="ins-name">79MPLUS</h6>
										<h6 class="degree">
											<span>2022-Present</span> | Wordpress Developer | Remote
										</h6>
										<p>
											Project based plugin development and Rest API integration
											to simplify client requirement within deadline.
										</p>
									</div>

									<div class="resume-item">
										<h6 class="ins-name">TECH PLEXUS LTD</h6>
										<h6 class="degree">
											<span>2018-2021</span> | Software Engineer
										</h6>
										<p>
											Responsible for working on a range of projects, designing
											appealing websites and interacting on a daily basis with
											graphic designers, back-end developers and marketers.
										</p>
									</div>

									<div class="resume-item">
										<h6 class="ins-name">FREELANCE</h6>
										<h6 class="degree">
											<span>2017-2018</span> | Web Developer
										</h6>
										<p>
											Worked with 30+ international clients with more than 50
											projects.
										</p>
									</div>
								</div>
							</div>
						</div>
						<!--                    <div class="award">-->
						<!--                        <div class="award-icon"></div>-->
						<!--                        <div class="award-content " style="border-color:#39b3ff;">-->
						<!--                            <div class="award-content-date mb-2">-->
						<!--                                <span>December 2018 </span>-->
						<!--                            </div>-->
						<!--                            <div class="award-content-header">-->
						<!--                                <h4 class="mb-3"><i class="fas fa-globe-asia mr-3 "></i> Senior Web Developer</h4>-->
						<!--                            </div>-->
						<!--                            <div class="award-content-body">-->
						<!--                                <p>-->
						<!--                                    Capitalize on low hanging fruit to identify a ballpark value added activity to beta test. Override the digital divide with additional clickthroughs from DevOps.-->
						<!--                                    Nanotechnology immersion along the information highway will close the loop on focusing solely on the bottom line.-->
						<!--                                </p>-->
						<!--                            </div>-->
						<!--                        </div>-->
						<!--                    </div>-->
						<!--                    <div class="award" v-view="inExperience">-->
						<!--                        <div class="award-icon"></div>-->
						<!--                        <div class="award-content" style="border-color: #ffc107;">-->
						<!--                            <div class="award-content-date mb-2">-->
						<!--                                <span>December 2018 </span>-->
						<!--                            </div>-->
						<!--                            <div class="award-content-header">-->
						<!--                                <h4 class="mb-3"><i class="fa fa-laptop mr-3 "></i> Web Developer</h4>-->
						<!--                            </div>-->
						<!--                            <div class="award-content-body">-->
						<!--                                <p>-->
						<!--                                    Capitalize on low hanging fruit to identify a ballpark value added activity to beta test. Override the digital divide with additional clickthroughs from DevOps.-->
						<!--                                    Nanotechnology immersion along the information highway will close the loop on focusing solely on the bottom line.-->
						<!--                                </p>-->
						<!--                            </div>-->
						<!--                        </div>-->
						<!--                    </div>-->
						<!--                    <div class="award" >-->
						<!--                        <div class="award-icon"></div>-->
						<!--                        <div class="award-content" style="border-color: #28a745;">-->
						<!--                            <div class="award-content-date mb-2">-->
						<!--                                <span>December 2018 </span>-->
						<!--                            </div>-->
						<!--                            <div class="award-content-header">-->
						<!--                                <h4 class="mb-3"><i class="fa fa-camera  mr-3 "></i> Junior Web Designer</h4>-->
						<!--                            </div>-->
						<!--                            <div class="award-content-body">-->
						<!--                                <p>-->
						<!--                                    Capitalize on low hanging fruit to identify a ballpark value added activity to beta test. Override the digital divide with additional clickthroughs from DevOps.-->
						<!--                                    Nanotechnology immersion along the information highway will close the loop on focusing solely on the bottom line.-->
						<!--                                </p>-->
						<!--                            </div>-->
						<!--                        </div>-->
						<!--                    </div>-->
						<!--                    <div class="award">-->
						<!--                        <div class="award-icon"></div>-->
						<!--                        <div class="award-content" style="border-color: rgb(212, 0, 255)">-->
						<!--                            <div class="award-content-date mb-2">-->
						<!--                                <span>December 2018 </span>-->
						<!--                            </div>-->
						<!--                            <div class="award-content-header">-->
						<!--                                <h4 class="mb-3"><i class="fas fa-chart-area mr-3 "></i> Web Design Intern</h4>-->
						<!--                            </div>-->
						<!--                            <div class="award-content-body">-->
						<!--                                <p>-->
						<!--                                    Capitalize on low hanging fruit to identify a ballpark value added activity to beta test. Override the digital divide with additional clickthroughs from DevOps.-->
						<!--                                    Nanotechnology immersion along the information highway will close the loop on focusing solely on the bottom line.-->
						<!--                                </p>-->
						<!--                            </div>-->
						<!--                        </div>-->
						<!--                    </div>-->
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	methods: {
		inExperience() {
			this.$emit("inExperience");
		},
	},
};
</script>

<style lang="scss" scoped></style>
